import React from "react";

import classNames from "classnames";
import ReCAPTCHA from "react-google-recaptcha";
import { useController } from "react-hook-form";

import { useConfig } from "../../api/internal";

import styles from "./Rate.module.scss";

export const Recaptcha = ({ name, control }) => {
  const { error, config } = useConfig();
  const {
    field: { value, onChange },
    fieldState: { invalid: isInvalid },
    formState: {},
  } = useController({
    name,
    control,
  });

  if (error) return <p>Failed to load config</p>;
  if (!config) return <p>Loading...</p>;

  const classes = classNames({
    "is-invalid": isInvalid,
    "form-control": false,
    [styles.rateInputWrapper]: true,
  });

  return (
    <div className={classes}>
      <ReCAPTCHA size="normal" sitekey={config.recaptchaSiteKey} onChange={onChange} />
    </div>
  );
};

export default Recaptcha;
